import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaCinemaUtility from '@sparta.global.utilities/cinema-utility/dist/es6.js';
import * as spartaHelper from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { cinemaHelper } from '@sparta.global.helpers/cinema-helper/dist/es6.js';
import * as buttonHelper from '@sparta.global.helpers/button-helper/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import _ from '@sparta.global.vendors/lodash';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';

/**
 * Utility modal-utility
 * @description Modal utility
 * @copyright 2019-9-13
 * @file
 */

const CSS_SELECTORS = {
  spaCinema: '.spa-cinema.spa-fn',
  spartaContainer: '[data-sparta-container]'
};

/**
 * @class ModalUtility
 */
class ModalUtility {
  /**
   * @method constructor
   * @description initializes new instance of ModalUtility Class
   */
  constructor() {
    this.videoLayers = {};
    this.isFirstLoad = true;
    this.addCustomInterstitialContent();
  }

  /**
   * Call modal functions based on the content provided
   * @param {Object} content - jcr content
   * @return {void}
   */
  init(content) {
    Handlebars.registerHelper('layerContent', spartaHelper.layerContent);
    Handlebars.registerHelper('button', buttonHelper.button);
    if (content.video) {
      this.appendVideoLayer(content);
      return;
    }
    const {
      layerContent
    } = content;
    if (layerContent) {
      Object.values(layerContent).forEach(layer => {
        if (layer.video) {
          this.appendVideoLayer(layer);
        }
      });
    }
  }

  /**
   * @description Add custom interstitial content retrieved
   * from `rel` `addContent` data option of the link
   * @method addCustomInterstitialContent
   * @return {void}
   */
  addCustomInterstitialContent() {
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_OPENED, event => {
      const {
        contentId,
        addContent
      } = event.data;
      if (contentId) {
        const layersCta = document.querySelector(`[rel="${contentId}"]`);
        if (layersCta) {
          const {
            options
          } = layersCta.dataset;
          try {
            const jsonData = JSON.parse(options);
            if (jsonData && jsonData.addContent) {
              addContent(jsonData.addContent);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    });
  }

  /**
   * @description Append video layer at the end of the main sparta container
   * @method appendVideoLayer
   * @param {Object} layer - modal layer data
   * @returns {void}
   */
  appendVideoLayer(layer) {
    if (this.isFirstLoad) {
      this.subVideoModalEvents(layer);
      this.spartaContainerEl = document.querySelector(CSS_SELECTORS.spartaContainer);
      this.isFirstLoad = false;
    }
    const modalLayerId = layer.id;
    this.videoLayers[modalLayerId] = layer;
    const templateString = `
        {{#layerContent this}}
          <div class="modal-container__layer">
            {{#if this.video}}
              {{{cinemaHelper this.video}}}
            {{/if}}
          </div>
        {{/layerContent}}`;
    Handlebars.registerHelper('cinemaHelper', cinemaHelper);
    const template = Handlebars.compile(templateString);
    requestAnimationFrame(() => {
      this.spartaContainerEl.insertAdjacentHTML('beforeend', template(_.defaultsDeep(layer)));
    });
  }

  /**
   * @description Subscribe to modal layer events related to videos
   * @method subVideoModalEvents
   * @param {*} content content
   * @returns {void}
   */
  subVideoModalEvents(content) {
    const videoEl = content.video.containerId;
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_OPENED, () => {
      spartaCinemaUtility.init(videoEl);
      const transcriptBtn = document.getElementById(`spaCinema_${videoEl}_transcript-button`);
      const transcriptBtnContent = `
        <i 
          id="spaCinema_bofaVideoExperience_transcript-icon"
          class="spa-icon spa-icon--helper spa-icon--textPos-left spa-icon spa-icon--helper--caretRight"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" role="img" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8.70149841,20 L7.29,18.5791119 L13.8769926,11.9949969 L7.29,5.4108818 L8.70149841,4 L16.71,11.9949969 C16.71,11.9949969 14.0404995,14.6633312 8.70149841,20 Z"></path>
          </svg>
        </i>
        View Transcript
      `;
      if (transcriptBtn) transcriptBtn.innerHTML = transcriptBtnContent;
    });
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_CLOSED, () => {
      const iframe = document.getElementsByTagName('iframe');
      if (iframe) {
        spartaCinemaUtility.destroyVideo(`spaCinema_${videoEl}`);
      }
    });
  }
}
var index = new ModalUtility();

export { index as default };
